import axios from '@/http/index';

const base = '';
// 删除房间信息
export const delRoomDetail = (params) => axios.get(`${base}/busmanage/room/deleteRoom`, params).then((res) => res.data);
// 获取房间信息
export const getRoomDetail = (params) => axios.get(`${base}/busmanage/room/getRoom`, params).then((res) => res.data);

// 获取房间列表
export const getRoomList = (params) => axios.get(`${base}/busmanage/room/list`, params).then((res) => res.data);

// 创建或更新房间
export const updateRoomDetail = (params) => axios.post(`${base}/busmanage/room/saveOrUpdateRoom`, params).then((res) => res.data);

// 预订房间
export const onBookingroom = (params) => axios.post(`${base}/room/bookRoom`, params).then((res) => res.data);

// 退房
export const onCheckOutRoom = (params) => axios.post(`${base}/room/checkOut`, params).then((res) => res.data);

// 获取房间详情
export const onGetRoomDetail = (params) => axios.get(`${base}/erp/room/listRoomInfoDetail`, params).then((res) => res.data);

// 获取房态
export const onGetRoomsDetail = (params) => axios.get(`${base}/room/listRoomInfos`, params).then((res) => res.data);

// 锁定房间
export const onLockUpRoom = (params) => axios.get(`${base}/room/lockRoom`, params).then((res) => res.data);

// 清除锁定状态
export const onUnlockRoom = (params) => axios.get(`${base}/room/outLockRoom`, params).then((res) => res.data);

// 设置脏房
export const onSetDirtyRoom = (params) => axios.get(`${base}/room/dirtyRoom`, params).then((res) => res.data);

// 设置净房
export const onCleanRoomFun = (params) => axios.get(`${base}/room/cleanRoom`, params).then((res) => res.data);

// 获取房间详情
export const onGetRoomDetailData = (params) => axios.get(`${base}/erp/room/getRoomInfoDetail`, params).then((res) => res.data);

// 由预订到入住
export const onBookToCheckin = (params) => axios.post(`${base}/room/checkin`, params).then((res) => res.data);

// 修改离店时间
export const onModificationCheckout = (params) => axios.post(`${base}/room/editRoomInfo`, params).then((res) => res.data);

// 换房
export const onChangeCheckoutRoom = (params) => axios.post(`${base}/erp/room/changeCheckoutRoom`, params).then((res) => res.data);

// 换房
export const onEditBookInfo = (params) => axios.post(`${base}/erp/room/editBookInfo`, params).then((res) => res.data);

// 可用房间
export const oncheckRoomStatus = (params) => axios.get(`${base}/erp/lookBookRoom/getRoomInfo`, params).then((res) => res.data);

// 查看指定时间房间是否可用
export const oncheckRoomUseful = (params) => axios.get(`${base}/erp/room/listUnusableResons`, params).then((res) => res.data);

// 查询房间日志
export const oncheckRoomlogs = (params) => axios.get(`${base}/erp/room/checkRoomLogs`, params).then((res) => res.data);

// 5.3远期房态-点击房间展示该房间所有预约信息
export const oncheckBookStatus = (params) => axios.get(`${base}/erp/lookBookRoom/getRoomInfoDtails`, params).then((res) => res.data);

// 查看房间实时房态
export const oncheckNowStatus = (params) => axios.get(`${base}/room/nowStatu`, params).then((res) => res.data);

// 取消预订
export const onCancleBooking = (params) => axios.get(`${base}/room/deleteBook`, params).then((res) => res.data);
// 导出房态详情信息
export const getRoomDataExcel = (params) => axios.get(`${base}
room/writeExcel`, params).then((res) => res.data);

// (4.7.0)获得顾客信息列表
export const getCustomerMsgList = (params) => axios.get(`${base}/erp/customer/getCustomerMsgList`, params).then((res) => res.data);
// 5.3实时房态-详情接口
export const getDateRoomDetails = (params) => axios.get(`${base}/room/getDateRoomDetails`, params).then((res) => res.data);
// 5.10今日预到列表
export const getDateRoomBook = (params) => axios.post(`${base}/room/getDateRoomBook`, params).then((res) => res.data);
// 5.10 房态-选择房间
export const getChooseRoomInfo = (params) => axios.post(`${base}/erp/lookBookRoom/chooseRoomInfo`, params).then((res) => res.data);
// 5.10 获取床位远期房态
export const roomBedInfoList = (params) => axios.get(`${base}/room/roomBedInfoList`, params).then((res) => res.data);
// 5.10房间记录
export const getRoomLogger = (params) => axios.get(`${base}/room/getRoomLogger`, params).then((res) => res.data);
// 5.10床位的房间详情和房间记录页面-下拉床位列表
export const queryBedByRoomId = (params) => axios.get(`${base}/room/queryBedByRoomId`, params).then((res) => res.data);
// 5.10今日预到页面-下拉房间-床位列表
export const queryBookRoomOrBed = (params) => axios.get(`${base}/room/queryBookRoomOrBed`, params).then((res) => res.data);
// 5.10实时床位
export const getRealTimeBed = (params) => axios.get(`${base}/room/getRealTimeBed`, params).then((res) => res.data);
// 5.10床位详情接口
export const getDateBedDetails = (params) => axios.get(`${base}/room/getDateBedDetails`, params).then((res) => res.data);
// 5.10点击退房，展示列表数据
export const getCheckOutDetails = (params) => axios.get(`${base}/room/getCheckOutDetails`, params).then((res) => res.data);
// (4.1订单详情)获得服务开单订单详情
export const getOrderDetail4AllDto = (param) => axios.get(`${base}/erp/customerOrder/getOrderDetail4AllDto`, param).then((res) => res.data);
// (6.7房间订单详情)
export const getRoomOrderMsg = (param) => axios.get(`${base}/room/getRoomOrderMsg`, param).then((res) => res.data);
// (6.7)获得房间订单列表
export const getRoomOrderListPage = (param) => axios.get(`${base}/room/getRoomOrderListPage`, param).then((res) => res.data);
// (6.7)获得订单项目列表信息
export const getRoomOrderItemList = (param) => axios.get(`${base}/room/getRoomOrderItemList`, param).then((res) => res.data);
// (6.8)查看房间预约信息
export const getBookRoomList = (param) => axios.get(`${base}/room/getBookRoomList`, param).then((res) => res.data);
